/* eslint-disable import-x/no-unresolved */
import uiConfig from '@onereach/ui-config';
import localOverrides from 'localOverrides';
import runningProjects from 'runningProjects';

import config from '../env.json';

type ExtendedConfig = typeof config & {
  sentry: {
    debug: boolean;
    dsn: string;
    enabled: boolean;
    environment: string;
    errorReplaySessions: number;
    maxBreadcrumbs: number;
    org: string;
    profilesRate: number;
    project: string;
    replaySessions: number;
    tracesSampleRate: number;
    url: string;
  };
};

export default uiConfig(config, localOverrides, runningProjects) as ExtendedConfig;
